import { Tooltip } from "@fluentui/react-components";
import { ICitation } from "models/ICitation";
import { useEffect, useRef, useState } from "react";
import { downloadFileFromCitation } from "utils/generalUtils";

export const CitationsTooltip = ({ citation, documentNumber, citationText }: { citation: ICitation; documentNumber: number, citationText: string }) => {
    const [showFull, setShowFull] = useState(false);
    const tooltipRef = useRef<HTMLDivElement>(null);

    const isLong = citationText && citationText.length > 250;
    const displayedText = showFull ? citationText : `${citationText.substring(0, 250)}...`;

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
                setShowFull(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <Tooltip
            content={
                <div ref={tooltipRef} style={{ maxWidth: "400px", padding: "10px", background: "white", color: "black", borderRadius: "5px", boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                    <strong>{citation.file_name}</strong>
                    <br />
                    {displayedText}
                    {isLong && (
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                setShowFull(!showFull);
                            }}
                            style={{
                                background: "none",
                                border: "none",
                                color: "blue",
                                cursor: "pointer",
                                textDecoration: "underline",
                                marginLeft: "5px"
                            }}
                        >
                            {showFull ? "Show less" : "Show more"}
                        </button>
                    )}
                </div>
            }
            relationship="description"
        >
            <span
                style={{
                    color: "blue",
                    cursor: "pointer",
                    textDecoration: "underline",
                    verticalAlign: "super",
                    margin: "0 2px",
                    fontSize: "0.6em",
                }}
                onClick={(e) => {
                    e.preventDefault();
                    downloadFileFromCitation(citation);
                }}
            >
                [{documentNumber}]
            </span>
        </Tooltip>
    );
};